import { useEffect, useState } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { keyframes } from '@mui/system';
import { useGeneral } from '../../context/general';
import { isAddressUpdateActive } from '../../utils/addressUpdateNotice';
import Loading from '../loading';

// import Tippy from "@tippy.js/react";
// import "tippy.js/dist/tippy.css";

const pulseGlow = keyframes`
  0%   { box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.55); }
  70%  { box-shadow: 0 0 0 14px rgba(255, 193, 7, 0); }
  100% { box-shadow: 0 0 0 0 rgba(255, 193, 7, 0); }
`;

const highlightSx = {
  p: 2,
  borderRadius: 2,
  border: '1px solid',
  borderColor: 'warning.main',
  animation: `${pulseGlow} 2s ease-out infinite`,
};

export default function ShippingAddress() {
  const [addressData, setAddressData] = useState({ seaFreightAdd: undefined, airFreightAdd: undefined });
  let Firstname = '';
  const { value } = useGeneral();
  const { clientInfo, seaFreightAdd, mailboxNum, airFreightAdd, fetchAddress, currentUser } = value;
  const showHighlight = isAddressUpdateActive();

  useEffect(() => {
    if (currentUser != null) {
      try {
        // console.log('about to enter fetch adddress', mailboxNum);
        if (mailboxNum === null || mailboxNum === undefined || mailboxNum === '') {
          fetchAddress(currentUser.uid, value);
        }
        // console.log(airFreightAdd);
        if (airFreightAdd !== undefined && seaFreightAdd !== undefined) {
          setAddressData({ airFreightAdd, seaFreightAdd });
        }
      } catch {
        // console.log("unable to fetch address");
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [airFreightAdd, currentUser, mailboxNum, fetchAddress]);

  if (
    value.clientInfo.fullName == null &&
    value.clientInfo.fullName === undefined &&
    value.clientInfo.fullName === ''
  ) {
    Firstname = 'Display Name';
  } else {
    Firstname = value.clientInfo.fullName;
  }

  if (addressData.seaFreightAdd === undefined && addressData.airFreightAdd === undefined) {
    return (
      <>
        <Loading />
      </>
    );
  }

  if (clientInfo.stateOrparish === 'Kingston') {
    return (
      <>
        <Box sx={showHighlight ? highlightSx : undefined}>
          <Stack component="span" direction="column" spacing={2}>
            <Typography />
            <Typography variant="p">
              <b>Your Name: </b>
              {/* {`${Firstname?.toUpperCase()} - ${mailboxNum}`} */}
              {`${Firstname?.toUpperCase()}`}
            </Typography>
            <Typography variant="p">
              <b>Address Line 1: </b>
              {`${airFreightAdd.addressLine1}`}
            </Typography>
            <Typography variant="p">
              <b>Address Line 2: </b>
              {`${airFreightAdd.addressLine2}-${mailboxNum}`}
            </Typography>
            <Typography variant="p">
              <b>City: </b>
              {airFreightAdd.city}
            </Typography>
            <Typography variant="p">
              <b>State: </b>
              {airFreightAdd.state}
            </Typography>
            <Typography variant="p">
              <b>Zip Code: </b>
              {airFreightAdd.zipCode}
            </Typography>
            <p />
          </Stack>
        </Box>
      </>
    );
  }

  if (clientInfo.stateOrparish === 'St. Catherine') {
    return (
      <>
        <Box sx={showHighlight ? highlightSx : undefined}>
          <Stack component="span" direction="column" spacing={2}>
            <Typography />
            <Typography variant="p">
              <b>Your Name: </b>
              {/* {`${Firstname?.toUpperCase()} - ${mailboxNum}`} */}
              {`${Firstname?.toUpperCase()}`}
            </Typography>
            <Typography variant="p">
              <b>Address Line 1: </b>
              {`${seaFreightAdd.addressLine1}`}
            </Typography>
            <Typography variant="p">
              <b>Address Line 2: </b>
              {/* {seaFreightAdd.addressLine2} */}
              {`${seaFreightAdd.addressLine2}-${mailboxNum}`}
            </Typography>
            <Typography variant="p">
              <b>City: </b>
              {seaFreightAdd.city}
            </Typography>
            <Typography variant="p">
              <b>State: </b>
              {seaFreightAdd.state}
            </Typography>
            <Typography variant="p">
              <b>Zip Code: </b>
              {seaFreightAdd.zipCode}
            </Typography>
            <p />
          </Stack>
        </Box>
      </>
    );
  }

  return (
    <>
      <Box sx={showHighlight ? highlightSx : undefined}>
        <Stack component="span" direction="column" spacing={2}>
          <Typography />
          <Typography variant="p">
            <b>Your Name: </b>
            {`${Firstname?.toUpperCase()} - ${mailboxNum}`}
          </Typography>
          <Typography variant="p">
            <b>Address Line 1: </b>
            {airFreightAdd.addressLine1}
          </Typography>
          <Typography variant="p">
            <b>Address Line 2: </b>
            {airFreightAdd.addressLine2}
          </Typography>
          <Typography variant="p">
            <b>City: </b>
            {airFreightAdd.city}
          </Typography>
          <Typography variant="p">
            <b>State: </b>
            {airFreightAdd.state}
          </Typography>
          <Typography variant="p">
            <b>Zip Code: </b>
            {airFreightAdd.zipCode}
          </Typography>
          <p />
        </Stack>
      </Box>
    </>
  );
}
